import React, { useState } from "react";
import DBListItem from "../../common/db-list/DBListItem";
import { genTermNames } from "../../utils/GeneralUtils";
import { SonicDBEntryData } from "../../common/classes/SonicDBEntry";
import AdvancedSearchPerson from "./AdvancedSearchPerson";
import ArchiveWrapper from "../../common/archive/ArchiveWrapper";
import JikeiToggleInput from "../../common/archive/JikeiToggleInput";
import { SearchParam } from "../../common/archive/ListSearchFunc";
import { SonicTermData } from "../../common/classes/SonicTerm";
import PageTitle from "../../common/PageTitle";
import PageHelperModal from "../../common/page-help/PageHelperModal";

type Props = {
  isLoading: boolean;
  personData: Array<SonicDBEntryData>;
  totalEntries: number;
  totalPages: number;
  currentPage: number;
  perView: number;
  keywordParam: string;
  gameParams: Array<string>;
  typeParams: Array<string>;
  verifiedParam: string;
  searchHandler: (params: Array<SearchParam>) => void;
  clearSearch: () => void;
  handlePerView: (value: number) => void;
  gameOptions: Array<SonicTermData>;
  playerTypeOptions: Array<SonicTermData>;
  handleSortJikei: (isJikei: string) => void;
  sortJikei: string;
};

const PersonDB: React.FC<Props> = ({
  isLoading,
  personData,
  totalEntries,
  totalPages,
  currentPage,
  perView,
  keywordParam,
  gameParams,
  typeParams,
  verifiedParam,
  searchHandler,
  clearSearch,
  handlePerView,
  gameOptions,
  playerTypeOptions,
  handleSortJikei,
  sortJikei,
}) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const handleHelpModal = () => {
    setShowModal(!showModal);
  };

  return (
    <main>
      <PageTitle
        title={"PROFILE"}
        subtext={"プロフィール"}
        handleHelpModal={handleHelpModal}
      />

      <ArchiveWrapper
        title={"プロフィール一覧"}
        hasResults={personData.length == 0 ? false : true}
        isLoading={isLoading}
        currentPage={currentPage}
        perView={perView}
        totalEntries={totalEntries}
        totalPages={totalPages}
        handlePerView={handlePerView}
        searchComponent={
          <>
            <AdvancedSearchPerson
              keywordParam={keywordParam}
              gameParams={gameParams}
              typeParams={typeParams}
              verifiedParam={verifiedParam}
              gameOptions={gameOptions}
              playerTypeOptions={playerTypeOptions}
              clearSearch={clearSearch}
              searchHandler={searchHandler}
            />
            <JikeiToggleInput
              sortJikei={sortJikei}
              handleSortJikei={handleSortJikei}
            />
          </>
        }
      >
        {personData.map((data, i) => {
          return (
            <DBListItem
              to={`/person/${data.id}`}
              key={i}
              tags={
                data.player_type ? genTermNames(data.player_type) : undefined
              }
              name={data.name}
              img_src={data.imgs?.[0]?.medium.url}
              logo_src={data.team?.[0]?.img?.thumbnail.url}
              team_color={data.team?.[0]?.color}
              isStudent={data.school ? true : false}
              verified={data.verified}
            />
          );
        })}
      </ArchiveWrapper>

      {showModal === true ? (
        <PageHelperModal
          handleHelpModal={handleHelpModal}
          helpTitle="プロフィールとは？"
          helpText={`プロフィールとは、SELeCT会員がユーザーから仕事やイベントのオファーをもらうために掲載する情報です。\n依頼したいプロフィールを見つけたら、ぜひオファーしてみましょう。`}
        />
      ) : null}
    </main>
  );
};

export default PersonDB;
